import Fetch from '../fetch/Fetch';
import { PlannerConfigEntity } from './PlannerConfigTypes';
import { PlannerEnv, envToBaseUrl } from '@/utils/env';
export class Staging {
  private baseUrl;

  constructor(env: PlannerEnv) {
    this.baseUrl = `${envToBaseUrl(env)}`;
  }

  public async getList(
    identifier?: string,
  ): Promise<Array<PlannerConfigEntity>> {
    let url = `${this.baseUrl}/staging/list`;

    if (identifier) {
      url += `?identifier=${identifier}`;
    }

    const response = await Fetch.json(url);
    //@ts-expect-error - response.data is not defined in Fetch.json
    return response.data as PlannerConfigEntity[];
  }

  /**
   * Get full list of identifiers
   * @returns {Promise<string[]>}
   */
  public async getIdentifiers() {
    const url = `${this.baseUrl}/staging/list`;

    const response = await Fetch.json(url);
    //@ts-expect-error - response.data is not defined in Fetch.json
    const data = response.data as PlannerConfigEntity[];

    return data.map((item) => item.identifier);
  }

  /**
   * Get planner data and marketConfig for a given id
   * @param {string} id - The id of the planner.
   * @returns  {Promise<PlannerConfigEntity>}
   */
  public async getPlannerData(id: string): Promise<PlannerConfigEntity> {
    const url = `${this.baseUrl}/staging/data/${id}`;
    const response = await Fetch.json(url);
    return response as PlannerConfigEntity;
  }

  /**
   * Adds a new planner in the Staging collection of type PlannerConfigEntity
   */
  public async addNewPlannerEntry(newPlanner: PlannerConfigEntity) {
    if (newPlanner) {
      const url = `${this.baseUrl}/staging/new`;
      return Fetch.json(url, {
        method: 'POST',
        body: JSON.stringify(newPlanner),
      });
    } else {
      throw new Error(`Invalid planner data: ${JSON.stringify(newPlanner)}`);
    }
  }

  /**
   * Updates data for a given planner id in Staging collection
   */
  public async updatePlannerData(
    updateData: Partial<PlannerConfigEntity>,
    id: string,
  ) {
    if (id) {
      const url = `${this.baseUrl}/staging/update/${id}`;
      await Fetch.json(url, {
        method: 'POST',
        body: JSON.stringify(updateData),
      }).catch((error: Error) => {
        if (error.message && !error.message?.includes('status 400')) {
          throw error;
        }
      });
    } else {
      throw new Error(`Invalid update data: ${JSON.stringify(updateData)}`);
    }
  }

  /**
   * Deletes a document and subcollections in Staging collection
   */
  public async deletePlanner(id: string) {
    if (id) {
      const url = `${this.baseUrl}/staging/delete/${id}`;
      await Fetch.json(url, {
        method: 'DELETE',
      }).catch((error: Error) => {
        if (error.message && !error.message?.includes('status 400')) {
          throw error;
        }
      });
    }
  }
}
